import AgoraRTC from "agora-rtc-sdk-ng";

export const getDevices = async () => {
    let videoDevices: MediaDeviceInfo[];
    try {
        videoDevices = await AgoraRTC.getCameras();
    }
    catch (e) {
        videoDevices = [];
    }

    let audioDevices: MediaDeviceInfo[];
    try {
        audioDevices  = await AgoraRTC.getMicrophones();
    }
    catch (e) {
        audioDevices = [];
    }
    return [videoDevices, audioDevices];
}

export const findDeviceById = (list: MediaDeviceInfo[], id: string | undefined, type: "video" | "audio" = "video"): MediaDeviceInfo | undefined => {
    return list.find(item => item.deviceId == id);
}